import { render, staticRenderFns } from "./RedMine.vue?vue&type=template&id=1461c8c6&"
import script from "./RedMine.vue?vue&type=script&lang=js&"
export * from "./RedMine.vue?vue&type=script&lang=js&"
import style0 from "./RedMine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports